import React, { useEffect, useState } from "react";
import { TextField, Button, Container, Grid, MenuItem } from "@mui/material";
// *******************************************
import axios from 'axios';
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { loadingDispatch } from "../../../app/utils";
import { fetchProjects } from "../../CommunityOnBoarding/ProjectSlice";
// ***************************************************

interface FormData {
  clientName: string;
  title: string;
  caseNoteDate: string;
  caseNoteTime: string;
  assignToStaff: string[];
  medicationReceived: string;
  foodProvided: string;
  personalCare: string;
  foodIntakeChartCompleted: string;
  participantMood: string;
  goalsMet: string;
  caseNoteDetails: string;
  timeTaken: number;
  rating: string;
  securityLevel: string;
}

const initialFormData: FormData = {
  clientName: "",
  title: "",
  caseNoteDate: new Date().toISOString().split("T")[0],
  caseNoteTime: new Date().toLocaleTimeString("en-US", { hour12: false }),
  assignToStaff: [],
  medicationReceived: "",
  foodProvided: "",
  personalCare: "",
  foodIntakeChartCompleted: "",
  participantMood: "",
  goalsMet: "",
  caseNoteDetails: "",
  timeTaken: 0,
  rating: "",
  securityLevel: "",
};

const assignToStaffOptions = [
  "Staff Member A",
  "Staff Member B",
  "Staff Member C",
];
const moodOptions = ["Fair", "Good", "Poor"];
const ratingOptions = ["Critical", "Important", "FYI"];
const medicationOptions = ["No", "Other", "Yes"];
const foodProvidedOptions = [
  "Bath",
  "Continence Care",
  "Dressing",
  "None",
  "Oral Hygiene",
  "Other",
  "Shower",
];
const foodIntakeChartOptions = ["Yes", "No"];
const securityLevelOptions = ["Low", "Medium", "High"];

const ShiftNotes: React.FC = () => {
  const [formData, setFormData] = useState<FormData>(initialFormData);


    // ==========*********************************************
    const [isError, setIsError] = useState(false);

    const { messages, loading, authenticated, user_details } = useAppSelector(
      (state) => state.appData
    );
    
    const [selectedProjectId, setSelectedProjectId] = useState('');
    
    const { projects, currentProject } = useAppSelector((state) => state.projectmanagement);
  
    const dispatch = useAppDispatch();
  
    useEffect(() => {
      setSelectedProjectId(currentProject || '');
      loadingDispatch(dispatch, [dispatch(fetchProjects())]);
    }, []);
  
    useEffect(() => {
      setIsError(false);
    }, [selectedProjectId]);
  
    // console.log("Show me the project ID", selectedProjectId)
  // *******************************************************

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDropdownChange =
    (name: keyof FormData) =>
    (event: React.ChangeEvent<{ value: unknown }>) => {
      const selectedValue = event.target.value as string;
      setFormData({
        ...formData,
        [name]: selectedValue,
      });
    };



  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setFormData(initialFormData); // Reset form data after submission

    const formDataObject = {
      ...formData,
      selectedProjectId: selectedProjectId,
      staff_email: user_details.email,
      staff_name: user_details.name
    };
    
    console.log(formDataObject); // Logging form data for demonstration

   
    try {
      // Make a direct API request using axios
      const response = await axios.post('http://localhost:7071/api/humanresources/ShiftNotesForm', formDataObject);
  
      // Handle the response as needed
      console.log('API response:', response.data);
  
      // Rest of your code
    } catch (error) {
      console.error("Error submitting personal details:", error);
    }
  };
  

  return (
    <Container>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              select
              label="Client Name"
              name="clientName"
              value={formData.clientName}
              onChange={handleChange}
              variant="outlined"
            >
              {["Client 1", "Client 2", "Client 3", "Client 4", "Client 5"].map(
                (client) => (
                  <MenuItem key={client} value={client}>
                    {client}
                  </MenuItem>
                )
              )}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Case Note Date"
              type="date"
              name="caseNoteDate"
              value={formData.caseNoteDate}
              onChange={handleChange}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Case Note Time"
              type="time"
              name="caseNoteTime"
              value={formData.caseNoteTime}
              onChange={handleChange}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Assign To Staff Member/s"
              name="assignToStaff"
              value={formData.assignToStaff}
              onChange={handleDropdownChange("assignToStaff")}
              SelectProps={{
                multiple: true,
              }}
              variant="outlined"
            >
              {assignToStaffOptions.map((staff) => (
                <MenuItem key={staff} value={staff}>
                  {staff}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Did the Participant receive their prescribed medication?"
              name="medicationReceived"
              value={formData.medicationReceived}
              onChange={handleDropdownChange("medicationReceived")}
              variant="outlined"
            >
              {medicationOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Did you provide the client with personal care?"
              name="personalCare"
              value={formData.personalCare}
              onChange={handleDropdownChange("personalCare")}
              variant="outlined"
            >
              {foodProvidedOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Have you completed the FOOD INTAKE CHART?"
              name="foodIntakeChartCompleted"
              value={formData.foodIntakeChartCompleted}
              onChange={handleDropdownChange("foodIntakeChartCompleted")}
              variant="outlined"
            >
              {foodIntakeChartOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Participant's Mood"
              name="participantMood"
              value={formData.participantMood}
              onChange={handleDropdownChange("participantMood")}
              variant="outlined"
            >
              {moodOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Which client goals have been met?"
              name="goalsMet"
              value={formData.goalsMet}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Enter the case note details below"
              multiline
              rows={4}
              name="caseNoteDetails"
              value={formData.caseNoteDetails}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Time Taken (mins)"
              type="number"
              name="timeTaken"
              value={formData.timeTaken}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              select
              label="Rating"
              name="rating"
              value={formData.rating}
              onChange={handleDropdownChange("rating")}
              variant="outlined"
            >
              {ratingOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              select
              label="Security Level"
              name="securityLevel"
              value={formData.securityLevel}
              onChange={handleDropdownChange("securityLevel")}
              variant="outlined"
            >
              {securityLevelOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default ShiftNotes;
